<template>
  <b-card body-class="p-0" header-class="border-0">
    <template v-slot:header>
      <i class="fas fa-info-circle" v-b-popover.hover.bottom="'This number represents units counted towards your unit goal.'"></i>
      <!-- Subtitle -->
      <h6 class="surtitle">Transaction Units</h6>
      <!-- Title -->
      <h5 class="h3">Annual Goal: {{ closedUnits }} Closed Units</h5>

      <base-progress class="mb-0"
                     type="success"
                     :striped="true"
                     :animated="true"
                     :height="5"
                     :showProgress="true"
                     :value="unitsPercent">
      </base-progress>
    </template>

    <b-list-group>
      <b-list-group-item class="d-flex justify-content-between align-items-center rounded-0 border-left-0 border-right-0">
        <h5 class="mb-0">Active</h5>
        <b-badge variant="primary" pill>{{ data.active }}</b-badge>
      </b-list-group-item>
      <b-list-group-item class="d-flex justify-content-between align-items-center rounded-0 border-left-0 border-right-0">
        <h5 class="mb-0">Pending</h5>
        <b-badge variant="primary" pill>{{ data.pending }}</b-badge>
      </b-list-group-item>
      <b-list-group-item class="d-flex justify-content-between align-items-center rounded-0 border-left-0 border-right-0">
        <h5 class="mb-0">Closed</h5>
        <b-badge variant="primary" pill>{{ data.closed }}</b-badge>
      </b-list-group-item>
      <b-list-group-item class="d-flex justify-content-between align-items-center rounded-0 border-left-0 border-right-0">
        <h5 class="mb-0">Total Pending & Closed</h5>
        <b-badge variant="primary" pill>{{ totalUnits }}</b-badge>
      </b-list-group-item>
    </b-list-group>
  </b-card>
</template>

<script>
import BaseProgress from '@/components/BaseProgress';
import errorsMixin from '@/mixins/errors-mixin';

export default {
  mixins: [errorsMixin],
  props: {
    data: null,
    closedUnits: null
  },
  components: {
    BaseProgress
  },
  computed: {
    totalUnits() {
      return this.data.pending + this.data.closed;
    },
    unitsPercent() {
      return Number((this.totalUnits / this.closedUnits * 100).toFixed(2));
    }
  }
};
</script>
<style>
.fa-info-circle {
  position: absolute;
  top: 3px;
  right: 3px;
}
.progress {
  margin-bottom: 0;
}
</style>